export enum DnaTestTrackingCategory {
    Home = "home",
    InLaboratory = "in_laboratory",
    ResultsReady = "results_ready",
}